import { isNumber } from "lodash";
import { Itinerary } from "../objects/itinerary";

type StepForBlockCheck = Pick<Itinerary, 'circuit' | 'iti_type'>;

// A step opens a block when it belongs to a package (circuit / typical trip) and the step above it is not
// part of the same one — the notion of block the UI renders through transformStepInputsToGroups, asked on
// a single pair so the date cascade (which only ever sees a pair) and insertPregirSteps can share it. The
// grouping is transitive on package-id equality, so comparing with the step above matches comparing with
// the group's first step.
export function isBlockFirstStep(
    previous: StepForBlockCheck | undefined,
    step: StepForBlockCheck
): boolean {
    if (!isNumber(step.circuit) && !isNumber(step.iti_type)) {
        return false;
    }

    if (!previous) {
        return true;
    }

    return !(
        (isNumber(previous.circuit) && previous.circuit === step.circuit) ||
        (isNumber(previous.iti_type) && previous.iti_type === step.iti_type)
    );
}
